import {
  TCaseAgentHarness,
  TOldCaseAgentHarness,
} from "../../../services/api/instances/casesApi/types";
import { FEASIBILITY_STATUS } from "../constants";
import { TCaseField, TFeasibilityStatus } from "../types";

export const getDisplayValue = (field: TCaseField) => {
  if (field.label !== "feasibility") return field.value;

  const existingPrefix = FEASIBILITY_STATUS.find((s) =>
    (field.value as string).startsWith(`${s} | `),
  );
  return existingPrefix
    ? (field.value as string).slice(`${existingPrefix}. `.length)
    : field.value;
};

export const getFeasibilityPrefix = (value: string): TFeasibilityStatus => {
  const foundPrefix = FEASIBILITY_STATUS.find((s) =>
    value.startsWith(`${s} | `),
  );
  return foundPrefix ?? "unknown";
};

export function convertCaseAgentHarness(
  oldHarness: TOldCaseAgentHarness,
): TCaseAgentHarness {
  const { long_term_memory, session_memory, rules } =
    oldHarness.case_agent_memory;

  const memory = `${long_term_memory} ${session_memory} ${rules}`;

  return {
    case_agent_services: oldHarness.case_agent_services,
    case_agent_memory: { memory },
    case_agent_skills: oldHarness.case_agent_skills,
    case_agent_info: oldHarness.case_agent_info,
    case_agent_tools: oldHarness.case_agent_tools,
  };
}
